import React from 'react'
import logo from '../../../assets/images/inferenz-logo.svg'
import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { BsPersonCircle } from 'react-icons/bs'
import { AiOutlineUserSwitch } from 'react-icons/ai'
import { FiLogOut } from 'react-icons/fi'

export const HeaderReimburse = () => {
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
  }
  return (
    <div className="headerEmployee w-100" style={{ height: '60px' }}>
      {' '}
      <nav aria-label="breadcrumb" className="bg-light rounded-3 p-2 mb-2 card">
        <ul className="breadcrumb mb-0 d-flex justify-content-between align-items-center">
          <li
            className="breadcrumb-item active"
            style={{ fontSize: '1.5rem' }}
            aria-current="page"
          >
            <Link className="link" to="/add-reimburse">
              <img src={logo} alt="logo" className="headerLogo" />
            </Link>
          </li>
          <ul className="d-flex justify-content-between align-items-center flex-row navbar-nav">
            <li
              className="mb-0 mx-3 nav-item"
              style={{
                fontSize: '16px',
                fontWeight: 600,
              }}
            >
              <Link className="nav-link" to="/add-reimburse" id="addReimburse">
                Home
              </Link>
            </li>
            <li
              className="mb-0 mx-3 nav-item"
              style={{
                fontSize: '16px',
                fontWeight: 600,
              }}
            >
              <Link
                className="nav-link"
                to="/view-reimburse"
                id="viewReimburse"
              >
                My Requests
              </Link>
            </li>
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item dropdown">
                <BsPersonCircle
                  style={{
                    width: '25px',
                    height: '25px',
                    marginTop: '0.3rem',
                    marginRight: '1rem',
                    color: '#0d6efd',
                  }}
                  className="rounded-circle"
                  height="35"
                  alt="Black and White Portrait of a Man"
                  loading="lazy"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                />

                <ul className="dropdown-menu">
                  <Link to="/portal" className="link">
                    <li
                      className="mx-2 d-flex"
                      style={{ cursor: 'pointer', height: '0.8rem' }}
                    >
                      <AiOutlineUserSwitch size={18} />
                      <h6 className="mt-1 mx-1">Switch portal</h6>
                    </li>
                  </Link>
                  <hr />
                  <li
                    data-bs-target="#exampleModal"
                    data-bs-toggle="modal"
                    className="mx-2 d-flex align-items-center"
                    style={{ cursor: 'pointer', height: '0.8rem' }}
                  >
                    <FiLogOut size={15} /> <h6 className="mt-2 mx-2">Logout</h6>
                  </li>
                </ul>
              </li>
            </ul>
          </ul>
        </ul>
      </nav>
      <div
        className="modal"
        tabIndex="-1"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to Logout from Intranet ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  logout()
                  navigate('/')
                }}
                data-bs-dismiss="modal"
              >
                Yes
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
